/**
 * AhirbhutamshaSection - Registration for D40 Ahirbhutamsha table in enhanced plugin system
 * Demonstrates mantra practice analysis through 8 AHI × 5 BHUTA divisions
 */

import { enhancedRegistry } from '../registry/EnhancedSectionRegistry';
import { AhirbhutamshaInfoTable } from '../components/AhirbhutamshaInfoTable';
import { JatakaResponse } from '../../../../../models/api';

// Import calculator to ensure it's registered
import '../calculators/AhirbhutamshaCalculator';

/**
 * Custom loading component for D40 Ahirbhutamsha
 */
const AhirbhutamshaLoadingSpinner: React.FC<{ progress?: number }> = ({ progress = 0 }) => {
    return (
        <div style={{
            padding: '20px',
            textAlign: 'center',
            background: '#fef3c7',
            borderRadius: '8px',
            border: '1px solid #fcd34d'
        }}>
            <div style={{
                fontSize: '14px',
                color: '#92400e',
                marginBottom: '12px'
            }}>
                🔮 Calculating D40 Ahirbhutamsha...
            </div>
            {progress > 0 && (
                <div style={{
                    width: '100%',
                    height: '4px',
                    backgroundColor: '#fde68a',
                    borderRadius: '2px',
                    overflow: 'hidden',
                    marginBottom: '8px'
                }}>
                    <div style={{
                        width: `${progress}%`,
                        height: '100%',
                        backgroundColor: '#f59e0b',
                        transition: 'width 0.3s ease'
                    }} />
                </div>
            )}
            <div style={{
                fontSize: '12px',
                color: '#6b7280'
            }}>
                {progress > 0 ? `${Math.round(progress)}% complete` : 'Analyzing mantra divisions...'}
            </div>
        </div>
    );
};

// Register the enhanced section
enhancedRegistry.register({
    id: 'ahirbhutamsha-d40',
    parentSection: 'Divisional',
    label: 'D40 Ahirbhutamsha',
    component: AhirbhutamshaInfoTable,
    type: 'table',
    order: 40, // After D12 (which is 30)

    // Lazy loading with D40 calculation
    lazy: {
        calculator: 'ahirbhutamsha-d40',
        loader: AhirbhutamshaLoadingSpinner,
        dependencies: ['graha_positions.planets']
    },

    // State persistence for table
    persistence: {
        enabled: true,
        stateKeys: ['expanded', 'sortOrder'],
        namespace: 'ahirbhutamsha-d40'
    },

    // Event monitoring disabled for production
    events: {},

    // Only show if we have planet data
    condition: (apiResponse: JatakaResponse) => {
        return apiResponse.graha_positions?.planets && apiResponse.graha_positions.planets.length >= 1;
    },

    // Component props
    componentProps: {
        showInterpretations: true,
        enableSorting: true,
        colorCoding: true
    }
});

// Export for backward compatibility
export { AhirbhutamshaInfoTable };
export default AhirbhutamshaInfoTable;
